import { Injectable } from '@angular/core';

import { SharedStoreService } from './shared-store.service';
import {Locale, LocaleUpdateFields} from '@emm/core/models/locale.model';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {MenuStoreService} from "@emm/menu/services/menu-store.service";
import {filter, map, take} from "rxjs/operators";
import {AuthState} from "@okta/okta-auth-js";

@Injectable({ providedIn: 'root' })
export class SharedFacadeService {

    attributeSelectedLocales$ = this.sharedStore.queryLocales.attributeSelectedLocales$;
    isAuthenticated$ = this.authFacade.isAuthenticated$;
    localeMappings$ = this.sharedStore.queryLocales.localeMappings$;
    localeOptions$ = this.sharedStore.queryLocales.localeOptions$;
    localeSelected$ = this.sharedStore.queryLocales.localeSelected$;
    origin$ = this.sharedStore.queryLocales.origin$;
    saved$ = this.sharedStore.queryLocales.saved$;
    currentTheme$ = this.sharedStore.queryTheme.currentTheme$;
    showTags$ = this.sharedStore.queryShowTags.showTags$;

    constructor(
        private authFacade: AuthFacadeService,
        private sharedStore: SharedStoreService,
        private menuStore: MenuStoreService,
    ) {}



    selectedLocale(locale: Locale): void {
        this.sharedStore.dispatch.selectedLocale(locale);
    }



    getAttributeLocaleFields(itemTag: string, attributeTag: string): void {
        this.sharedStore.dispatch.getAttributeLocaleFields(itemTag, attributeTag);
    }



    resetSaved(): void {
        this.sharedStore.dispatch.resetSaved();
    }



    saveAttributeLocaleFields(itemTag: string, updatedFields: LocaleUpdateFields[], origin: string): void {
        this.sharedStore.dispatch.saveAttributeLocaleFields(itemTag, updatedFields, origin);
    }



    init(): void {
        this.sharedStore.dispatch.init();
        this.isAuthenticated$.pipe(take(1)).subscribe((value) => {
            if (value) {
                this.sharedStore.dispatch.getLocaleOptions();
                this.sharedStore.dispatch.getLocaleMappings();
            }
        });
    }

    initTheme(): void {
        this.sharedStore.dispatch.initTheme();
    }
    selectTheme(theme: string): void {
        this.sharedStore.dispatch.selectTheme(theme);
    }

    initShowTags(): void {
        this.sharedStore.dispatch.initShowTags();
    }
    selectShowTags(showTags: string): void {
        this.sharedStore.dispatch.selectShowTags(showTags);
    }

    getSelectedSearchSubmenu() {
        let submenu = null;
        this.menuStore.querySubmenus.selectedSearchSubmenu$.pipe(take(2)).subscribe(value =>
            submenu = value);
        return {submenu};
    }
}
